<template>
  <v-layout>
    <v-data-table :headers="headers" :items="items" style="flex: 1 1 auto">
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item }}</td>
          <td>
            <template>
              <v-btn color="error" small @click="deleteSkipValue(props.item)">Delete</v-btn>
            </template>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="addSkipValueModal" persistent max-width="500">
      <v-card>
        <v-card-title class="title">
          Add Skip Value
          <v-spacer />
          <v-btn icon @click.native="closeAddForm">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="addForm" v-model="addForm.valid">
          <v-card-text pa-2>
            <v-text-field label="Skip Value" v-model="addForm.values.skipValue" :rules="addForm.rules.skipValue">
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="submitAddForm" :disabled="!addForm.valid">Add</v-btn>
            <v-btn color="secondary" @click="closeAddForm">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  export default {
    props: {
      configName: {
        type: String,
        required: true,
      },
      columnConfiguration: {
        type: Object,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        addSkipValueModal: false,
        headers: [{
          text: 'Skip Value',
          align: 'left',
          value: 'Name',
          width: '60%',
          sortable: false,
        },
        {
          text: 'Actions',
          align: 'left',
          value: '',
          width: '40%',
          sortable: false,
        },
        ],
        addForm: {
          values: {
            skipValue: '',
          },
          rules: {
            skipValue: [
              v => !!v || 'Skip value cannot be blank',
              v => (!this.columnConfiguration.SkipValues.includes(v)) ||
              'Skip value already exists',
            ],
          },
          valid: true,
        },
      }
    },
    computed: {
      items() {
        console.log(this.columnConfiguration)
        let items = (this.columnConfiguration && this.columnConfiguration.SkipValues) || []
        // place default alias on top
        items.sort((a, b) => {
          if (a.IsDefault) {
            return -1
          }
          if (b.IsDefault) {
            return 1
          }
          return a <= b ? -1 : 1
        })
        console.log(items)
        return items
      },
    },
    methods: {
      ...eddConfiguration.mapActions(['insertSkipValue', 'deleteColumnSkipValue']),
      deleteSkipValue(skipValueName) {
        this.deleteColumnSkipValue({
          configName: this.configName,
          columnId: this.columnConfiguration.Id,
          skipValue: skipValueName,
        })
      },
      openAddSkipValue() {
        this.addSkipValueModal = true
      },
      resetAddForm() {
        this.addForm.values = {
          skipValue: '',
        }
        this.$refs.addForm.resetValidation()
      },
      submitAddForm() {
        this.insertSkipValue({
          configName: this.configName,
          columnId: this.columnConfiguration.Id,
          skipValue: this.addForm.values.skipValue,
        })
        this.closeAddForm()
      },
      closeAddForm() {
        this.addSkipValueModal = false
        this.resetAddForm()
      },
    },
  }
</script>